import {SignatureEditorData} from '@mydocma/component-library';


export const signaturePoints:SignatureEditorData  = {
  pointGroups: [
    {
      color: 'black',
      points: [
        {
          time: 1731329970200,
          x: 254.06661713123322,
          y: 138.95648193359375
        },
        {
          time: 1731329970452,
          x: 244.1540652513504,
          y: 138.32269287109375
        },
        {
          time: 1731329970470,
          x: 236.78588593006134,
          y: 137.10821533203125
        },
        {
          time: 1731329970487,
          x: 229.3232547044754,
          y: 135.918212890625
        },
        {
          time: 1731329970504,
          x: 222.06504547595978,
          y: 134.96405029296875
        },
        {
          time: 1731329970520,
          x: 214.82674896717072,
          y: 134.06640625
        },
        {
          time: 1731329970555,
          x: 206.02163422107697,
          y: 133.42694091796875
        },
        {
          time: 1731329970571,
          x: 198.54433929920197,
          y: 133.3446044921875
        },
        {
          time: 1731329970588,
          x: 190.1609011888504,
          y: 134.108154296875
        },
        {
          time: 1731329970605,
          x: 181.05399811267853,
          y: 136.92822265625
        },
        {
          time: 1731329970623,
          x: 171.37019073963165,
          y: 142.0152587890625
        },
        {
          time: 1731329970640,
          x: 159.8902713060379,
          y: 149.02996826171875
        },
        {
          time: 1731329970657,
          x: 148.42048370838165,
          y: 156.8614501953125
        },
        {
          time: 1731329970673,
          x: 138.6994754076004,
          y: 164.7581787109375
        },
        {
          time: 1731329970691,
          x: 127.08620178699493,
          y: 175.95391845703125
        },
        {
          time: 1731329970707,
          x: 123.7995730638504,
          y: 180.3673095703125
        },
        {
          time: 1731329970741,
          x: 120.92751038074493,
          y: 188.7391357421875
        },
        {
          time: 1731329970757,
          x: 120.19085419178009,
          y: 193.84100341796875
        },
        {
          time: 1731329970774,
          x: 119.79324066638947,
          y: 199.555419921875
        },
        {
          time: 1731329970791,
          x: 119.50525391101837,
          y: 206.5477294921875
        },
        {
          time: 1731329970807,
          x: 119.28681671619415,
          y: 214.346923828125
        },
        {
          time: 1731329970824,
          x: 119.15135681629181,
          y: 221.77587890625
        },
        {
          time: 1731329970840,
          x: 119.15135681629181,
          y: 228.6865234375
        },
        {
          time: 1731329970857,
          x: 119.25048553943634,
          y: 234.69677734375
        },
        {
          time: 1731329970891,
          x: 121.1776248216629,
          y: 243.5155029296875
        },
        {
          time: 1731329970924,
          x: 125.90523254871368,
          y: 251.5556640625
        },
        {
          time: 1731329970941,
          x: 129.38351166248322,
          y: 255.82891845703125
        },
        {
          time: 1731329970957,
          x: 133.50756561756134,
          y: 260.0792236328125
        },
        {
          time: 1731329970974,
          x: 138.11047089099884,
          y: 264.14111328125
        },
        {
          time: 1731329970991,
          x: 142.93314850330353,
          y: 267.9884033203125
        },
        {
          time: 1731329971008,
          x: 147.1768923997879,
          y: 271.06494140625
        },
        {
          time: 1731329971041,
          x: 155.36185944080353,
          y: 276.08245849609375
        },
        {
          time: 1731329971074,
          x: 164.28559601306915,
          y: 280.1182861328125
        },
        {
          time: 1731329971108,
          x: 171.93295013904572,
          y: 281.84100341796875
        },
        {
          time: 1731329971141,
          x: 181.38996613025665,
          y: 282.8553466796875
        },
        {
          time: 1731329971157,
          x: 186.55675995349884,
          y: 282.8553466796875
        },
        {
          time: 1731329971174,
          x: 192.51487457752228,
          y: 282.8553466796875
        },
        {
          time: 1731329971191,
          x: 199.44187653064728,
          y: 282.43719482421875
        },
        {
          time: 1731329971207,
          x: 207.44936859607697,
          y: 281.1116943359375
        },
        {
          time: 1731329971224,
          x: 215.4470797777176,
          y: 279.214111328125
        },
        {
          time: 1731329971241,
          x: 221.65610992908478,
          y: 277.41522216796875
        },
        {
          time: 1731329971258,
          x: 227.5363894701004,
          y: 275.35272216796875
        },
        {
          time: 1731329971274,
          x: 233.63444244861603,
          y: 272.92529296875
        },
        {
          time: 1731329971291,
          x: 239.57937347888947,
          y: 270.29925537109375
        },
        {
          time: 1731329971307,
          x: 245.96130096912384,
          y: 267.1500244140625
        },
        {
          time: 1731329971324,
          x: 251.55575287342072,
          y: 264.04815673828125
        },
        {
          time: 1731329971342,
          x: 256.52578461170197,
          y: 260.94573974609375
        },
        {
          time: 1731329971360,
          x: 260.6495028734207,
          y: 258.0238037109375
        },
        {
          time: 1731329971394,
          x: 264.1947604417801,
          y: 254.2015380859375
        },
        {
          time: 1731329971428,
          x: 268.77599823474884,
          y: 246.42938232421875
        },
        {
          time: 1731329971460,
          x: 275.2718173265457,
          y: 234.81829833984375
        },
        {
          time: 1731329971476,
          x: 278.77050507068634,
          y: 228.4873046875
        },
        {
          time: 1731329971510,
          x: 280.8774081468582,
          y: 223.58331298828125
        }
      ]
    }
  ],
  width: 398,
  height: 398
}
